/** --------------------- Interfaces----------------------------  */
// User data interface
export interface UserData {
    id: string,
    firstName: string,
    lastName: string,
    email: string,
    siteName: string[],
    status:string,
    preferredLanguage:string
}

// Logged in user interface
export interface LoggedInUser {
   firstName: string,
   lastName: string,
   email: string, 
   applicationId : string,
   salesforceId : string,
   roles : Array <string>,
   preferredLanguage:string
}

// User site interface
export interface SiteData {
    id : string,
    label: string,
    value: string
}

// Delete user Response
export interface DeleteResponse {
  userId: string;
  success: boolean;
  error: string;
}

// User list props
export type UserListProps = {
  siteMetaData: SiteData[];
};

// User form props
export type UserFormProps = {
  siteMetaData: SiteData[];
};

export const LoggedInUserDefaultData: LoggedInUser = {
  firstName: "",
  lastName: "",
  email: "",
  applicationId: "",
  salesforceId: "",
  roles: [],
  preferredLanguage: ""
};

/*  ----------------------- Constants ------------------------------ */
// User table header list
const USER_LIST_HEADER = [
    "First Name",
    "Last Name",
    "Email",
    "Site Names",
    "Actions"
];

// User statis
export enum UserStatus {
    Invited = 0,
    Active = 1
} 

// Per page recods
const DATA_PER_PAGE = 100;
const DELETE_CONFIRMATION_TITLE = "Confirm Remove";
const DELETE_CONFIRMATION_MSG = "Are you sure you want to delete the selected user(s)?";
const ERROR_FETCH_USER = "Unable to fetch user details. Please try again.";
const ERROR_UPDATE_USER = "Unable to update user. Please try again.";
const ERROR_ADD_USER = "Unable to create user. Please try again.";
const ERROR_DELETE_USER = "Unable to delete user(s). Please try again.";
const ERROR_FETCH_SITE = "Unable to fetch customer site data. Please try again.";
const USER_ADDED = "User has been created successfully.";
const USER_UPDATED = "User has been updated successfully.";
const ERROR_FIRSTNAME_REQUIRED = "First name is required.";
const ERROR_LASTNAME_REQUIRED = "Last name is required.";
const ERROR_EMAIL_REQUIRED = "A valid email address is required.";
const USER_DELETED = "User(s) have been deleted successfully.";


// Export all constants
export const UserConstants = {
    USER_LIST_HEADER,
    DELETE_CONFIRMATION_TITLE,
    DELETE_CONFIRMATION_MSG,
    DATA_PER_PAGE,
    ERROR_FETCH_USER,
    ERROR_ADD_USER,
    ERROR_DELETE_USER,
    ERROR_FETCH_SITE,
    USER_ADDED,
    ERROR_FIRSTNAME_REQUIRED,
    ERROR_LASTNAME_REQUIRED,
    ERROR_EMAIL_REQUIRED,
    USER_DELETED,
    ERROR_UPDATE_USER,
    USER_UPDATED
}
